import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../videoMeeting.constants";
import { fetchVideoMeetingDetails } from "../utils/fetchVideoMeetingDetails";
import type { MeetingDetails } from "../videoMeeting.types";

export type UseFetchVideoMeetingDetailsArgs = {
  meetingId: number | string | null;
  user: { id: number } | null;
  isEnabled?: boolean;
};

export function useFetchVideoMeetingDetails({
  meetingId,
  user,
  isEnabled = true,
}: UseFetchVideoMeetingDetailsArgs) {
  return useQuery<MeetingDetails, Error>({
    queryKey: [QUERY_KEYS.VIDEO_MEETING_DETAILS, meetingId],
    queryFn: () => fetchVideoMeetingDetails(meetingId!),
    enabled: !!meetingId && !!user && isEnabled,
  });
}
